<template>
    <div class="user-page">
      <iframe
        :src="state.url"
        frameborder="0"
        scrolling="auto"
        id="iframename"
        name="iframename"
      ></iframe>
    </div>
  </template>
  
  <script>
  import {  useRouter,useRoute } from "vue-router";
  import { reactive,onMounted } from "vue";
  import { Toast } from 'vant';
  import { useStore } from "vuex";
  import { getQueryString } from "@/utils/location";
  export default {
    name: "web-activity",
    setup() {
      const route = useRoute();
      const router = useRouter();
      const store = useStore();
      const state = reactive({
        // url: '',
        url:route.query.url,
        titleStr:route.query.title
      });
      // 返回
      const onClickLeft = () => {
        router.back();
      };
  
      const getUrl = () => {
        if(route.query.type == 'NewGift'){
           let paras = "?username=" + store.state.username + "&key=" + getQueryString("key");
           state.url =  "http://abc.5535.cn/Activity/index/sendFirstDkj" + paras;
           console.log('url = ' + state.url)
        }
      };
  
  
      onMounted(() => {
        getUrl();
        window.addEventListener("message", function (e) {
          console.log("messageType = " + e.data.eventType)
          // 监听 message 事件
          if (e.origin !== "http://abc.5535.cn") {
            // 验证消息来源地址
            return;
          }
  
          if (e.data.eventType == "titleEvent") {
            state.titleStr = e.data.title;
          }else if(e.data.eventType == "toastEvent"){
            Toast(e.data.toastStr)
          }
        });
      });
  
      window["vueDefinedMyProp"] = (receiveParams) => {
        console.log(receiveParams);
      };
  
      return {
        state,
        onClickLeft,
      };
    },
  };
  </script>
  <style scoped="scoped">
  /* .van-nav-bar {
    position: fixed;
    left: 0px;
    width: 100%;
    padding-top: constant(safe-area-inset-top); 
    padding-top: env(safe-area-inset-top); 
  } */
  .van-hairline--bottom::after {
    border-bottom-width: 0px;
  }
  
  .service-page:deep(.van-nav-bar__title) {
    color: #fff;
  }
  
  #iframename {
    width: 100%;
    /* height: -webkit-fill-available; */
    min-height: 100vh;
  }
  .user-page {
    padding-top: calc(50px + constant(safe-area-inset-top));
    padding-top: calc(50px + env(safe-area-inset-top));
  }
  </style>